<template>
  <Layout>
    <Content :style="{'padding': '10px'}">
      <Breadcrumb :style="{margin: '5px 0'}">
        <BreadcrumbItem>通用管理 > <b>开放平台</b></BreadcrumbItem>
      </Breadcrumb>
      <Card>
		  <span class="search_span_width">
		  <span class="search_span_width_part1">APPKEY：</span>
		  	<Input v-model="search.appkey" clearable style="width: 200px" />
		  </span>
		  <Button type='primary' icon="ios-search" :style="{'margin-left':'20px'}" @click="getAppList(1)">搜索</Button>
		<span :style="{'margin-left':'20px'}">
			<Button type='primary' :style="{'margin-left':'5px'}" @click="addModal()">添加</Button>
		</span>
        <Card id="tableContent" >
          <Table :columns="tableColumns" :data="app_list"></Table>
          <Page :total="recordTotal" :current="page" :page-size="20" :show-elevator="true" @on-change="getAppList"/>
        </Card>
      </Card>
    </Content>
    <Modal v-model="showmodal" :footer-hide=true title="开放平台">
      <Form ref="app" :model="app" :label-width="80" >
        <FormItem label="备注" prop="remark">
          <Input v-model="app.remark"  />
        </FormItem>
		<FormItem label="渠道" prop="channel">
		  <Select v-model="app.channel" clearable style="width:130px">
		    <Option v-for="(item,index) in channel_list" :value="item.id" :key="index">{{ item.name }}</Option>
		  </Select>
		</FormItem>
        <FormItem label="appkey" prop="content" v-show="app.id>0">
          <Input v-model="app.appkey"  readonly/>
        </FormItem>
        <FormItem label="appsecret" prop="appsecret" v-show="app.id>0">
          <Input v-model="app.appsecret" readonly/>
        </FormItem>
        <FormItem label="user_ids" prop="user_ids">
          <Input v-model="app.user_ids"/>
        </FormItem>
        <FormItem label="开始时间" prop="start_time">
          <DatePicker type="date" placeholder="Select date" style="width: 200px" v-model="app.start_time"></DatePicker>
        </FormItem>
        <FormItem label="结束时间" prop="end_time">
          <DatePicker type="date" placeholder="Select date" style="width: 200px" v-model="app.end_time"></DatePicker>
		  </FormItem>
        <FormItem label="状态" prop="status">
            <RadioGroup v-model="app.status">
              <Radio label="-1">禁用</Radio>
              <Radio label=1>正常</Radio>
            </RadioGroup>
        </FormItem>

        <FormItem>
          <Button type="primary" @click="updateApp()">提交</Button>
        </FormItem>
      </Form>
    </Modal>
	<Modal v-model="showmodaldialog" :footer-hide=true title="对话并发配置">
	  <Form ref="dialog" :model="dialog" :label-width="80" >
		  <FormItem label="并发类型" prop="recharge_type" style="width: 200px" >
		    <Select v-model="dialog.recharge_type">
		      <Option :value='30'>专属</Option>
		      <Option :value='31'>通用</Option>
			  <Option :value='34'>公共</Option>
			  <Option :value='32'>4K</Option>
		    </Select>
		  </FormItem>
	    <FormItem label="并发数" prop="concurrency">
	      <InputNumber v-model="dialog.concurrency" :min='0' controls-outside></InputNumber>
	    </FormItem>

	    <FormItem label="开始时间" prop="start_time">
	      <DatePicker type="date" placeholder="Select date" style="width: 200px" v-model="dialog.start_time"></DatePicker>
	    </FormItem>
	    <FormItem label="结束时间" prop="end_time">
	      <DatePicker type="date" placeholder="Select date" style="width: 200px" v-model="dialog.end_time"></DatePicker>
		</FormItem>
	
	    <FormItem>
	      <Button type="success" @click="updateRecharge()">提交</Button>
	    </FormItem>
	  </Form>
	  <Table :columns="rechargeColumns" :data="recharge_list"></Table>
	</Modal>
  </Layout>
</template>
<script>
const OSS = require('ali-oss');
export default {
  data(){
    return {
	  search:{
		appkey:''  
	  },
      date: '',
      selectedTime: '',
      showmodal:false,
	  showmodaldialog:false,
	  showmodallog:false,
      isShowService:false,
      file:null,
      loadingStatus:false,
      upLoadProgress:0,
      upLoadProgress_show:false,
      app_list:[],
      recordTotal:0,
	  page:1,
      channel_list:[],
	  recharge_list:[],
      app:{
        id:0,
        remark:'',
        appkey:'',
        appsecret:'',
        user_ids:'',
        start_time:'',
        end_time:'',
        status:'1',
		channel:'all',
      },
	  dialog:{
		  open_id:0,
		  concurrency:0,
		  start_time:'',
		  end_time:'',
		  recharge_type:30
	  },
	  rechargeColumns:[
		  { title: '并发类型', key: 'recharge_type', align: 'center',render:(h,params) =>{
            var name = '未知';
            if(params.row.recharge_type==30){
              name = '专属';
            }
            if(params.row.recharge_type==31){
              name = '通用';
            }
			if(params.row.recharge_type==32){
			  name = '4K';
			}
			if(params.row.recharge_type==33){
			  name = '照片';
			}
			if(params.row.recharge_type==34){
			  name = '公共';
			}
            return h('span',{},name);
          } },
		  { title: '开始时间', key: 'start_time', align: 'center' },
		  { title: '结束时间', key: 'end_time', align: 'center' },
		  { title: '并发数', key: 'recharge_time', align: 'center' },
	  ],
	  tableColumns:[
        { title: '备注', key: 'remark', align: 'center' },
		{ title: '渠道', key: 'channel', align: 'center' },
        { title: 'appkey', key: 'appkey', align: 'center' ,render:(h,params) =>{
            let btns=[]
            if( params.row.isAppkey){
              btns.push(h('div',{},params.row.appkey));
              btns.push(
                  h('Icon', {
                    props: { type: 'ios-eye-outline', size: '20px' },
                    style: { marginRight: '5px', marginBottom: '5px'},
                    on: {
                      click: () => {
                        params.row.isAppkey = 0;
                      }
                    }
                  }, ''),
              );
            }else{
              btns.push(h('div',{},'*******'));
              btns.push(
                  h('Icon', {
                    props: { type: 'ios-eye', size: '120px' },
                    style: { marginRight: '5px', marginBottom: '5px'},
                    on: {
                      click: () => {
                        params.row.isAppkey = 1;
                      }
                    }
                  }, ''),
              );
            }


            return h('div',{},btns);
          } },
        { title: 'appsecret', key: 'appsecret', align: 'center' ,render:(h,params) =>{
            let btns=[]
            if( params.row.isService){
              btns.push(h('div',{},params.row.appsecret));
              btns.push(
                  h('Icon', {
                    props: { type: 'ios-eye-outline', size: '20px' },
                    style: { marginRight: '5px', marginBottom: '5px'},
                    on: {
                      click: () => {
                        params.row.isService = 0;
                      }
                    }
                  }, ''),
              );
            }else{
              btns.push(h('div',{},'*******'));
              btns.push(
                  h('Icon', {
                    props: { type: 'ios-eye', size: '120px' },
                    style: { marginRight: '5px', marginBottom: '5px'},
                    on: {
                      click: () => {
                        params.row.isService = 1;
                      }
                    }
                  }, ''),
              );
            }
            return h('div',{},btns);
          } },
        { title: '用户手机号', key: 'mobileList', align: 'center',width : '150px',render:(h,params) =>{
            var mobileSpans = [];
            for (var i=0;i<params.row.mobileList.length;i++)
            {
              mobileSpans.push(
                  h('div',{},params.row.mobileList[i])
              );
            }
            return mobileSpans;
          } },
		{ title: '对话并发', key: 'talk_concurrency', align: 'center' },
        { title: '开始时间', key: 'start_time', align: 'center' },
        { title: '结束时间', key: 'end_time', align: 'center' },
        { title: '状态', key: 'status', align: 'center' ,render:(h,params) =>{
            var name = '未知';
            if(params.row.status==1){
              name = '正常';
            }
            if(params.row.status==-1){
              name = '禁用';
            }
            return h('span',{},name);
          }},
        { title: '操作', key: 'action', align: 'center',
          render: (h, params) => {
            let btns=[]
            btns.push(
                h('Button', {
                  props: { type: 'warning', size: 'small' },
                  style: { marginRight: '5px', marginBottom: '5px'},
                  on: {
                    click: () => {
                      this.app.id = params.row.id;
                      this.app.remark = params.row.remark;
                      this.app.appkey = params.row.appkey;
                      this.app.appsecret = params.row.appsecret;
                      this.app.user_ids = params.row.user_ids;
                      this.app.start_time = params.row.start_time;
                      this.app.end_time = params.row.end_time;
                      this.app.status = params.row.status.toString();
					  this.app.channel = params.row.channel;
                      this.showmodal = true;
                    }
                  }
                }, '编辑'),
            );
			btns.push(
			    h('Button', {
			      props: { type: 'success', size: 'small' },
			      style: { marginRight: '5px', marginBottom: '5px'},
			      on: {
			        click: () => {
						this.dialog.open_id = params.row.id;
						this.dialog.start_time = '';
						this.dialog.end_time = '';
						this.dialog.concurrency = 0;
						this.getRechargeList(params.row.id);
						this.showmodaldialog = true;
			        }
			      }
			    }, '对话并发'),
			);
            return h("div",btns);
          }
        }
      ]
    }
  },
  mounted:function(){
    this.getAppList();
	this.getChannelList();
  },
  computed:{

  },
  methods:{
    addModal(){
      this.app.id = 0;
      this.app.remark = '';
      this.app.appkey = '';
      this.app.appsecret = '';
      this.app.user_ids = '';
      this.app.start_time = '';
      this.app.end_time = '';
      this.status = 1;
	  this.app.live_concurrency = 0;
	  this.app.channel = 'all';
      this.showmodal = true;
    },
    getAppList(page=this.page) {
      this.page = page;
      let p = {'page' : page}
      let params = Object.assign(this.search, p);
      this.http1.get('/open/open-list',{params:params}).then(response=>{
        let data=response.data;
        if(data.code!==0){
          alert(data.message);
        } else{
          this.app_list = data.res.list;
          for(let i = 0, len = this.app_list.length; i <len; i++) {
            let isService = {'isService' : 0}
            let isAppkey = {'isAppkey' : 0}
            this.app_list[i] = Object.assign(this.app_list[i], isService);
            this.app_list[i] = Object.assign(this.app_list[i], isAppkey);
          }
          this.recordTotal = data.res.total;
        }
      }).catch(()=>{
        this.$Message.error('网络错误');
      });
    },
    updateApp(){
      this.http1.post('/open/edit-open-app',{
        open_id:this.app.id,
        remark:this.app.remark,
        user_ids:this.app.user_ids,
        start_time:this.app.start_time,
        end_time:this.app.end_time,
        status:this.app.status,
		channel:this.app.channel,
		live_concurrency:this.app.live_concurrency
      }).then(response=>{
        let data=response.data;
        if(data.code!==0) {
          this.$Message.error(data.message);
          return false;
        } else{
          this.$Message.info(data.message);
          this.showmodal = false;
          this.getAppList();
          return true;
        }
      });
    },
	updateRecharge(){
	  this.http1.post('/open/edit-recharge',{
	    open_id:this.dialog.open_id,
	    start_time:this.dialog.start_time,
	    end_time:this.dialog.end_time,
		concurrency:this.dialog.concurrency,
		recharge_type:this.dialog.recharge_type
	  }).then(response=>{
	    let data=response.data;
	    if(data.code!==0) {
	      this.$Message.error(data.message);
	      return false;
	    } else{
	      this.$Message.info(data.message);
	      this.showmodaldialog = false;
	      this.getAppList(this.page);
	      return true;
	    }
	  });
	},
	getChannelList(){
	  this.http.get('/admin/agent/channelList').then(response=>{
	    let data=response.data;
	    if(data.code!==0)
	    {
	      alert(data.message);
	    } else{
	      if (data.data) {
	        this.channel_list = data.data;
	      }
	    }
	  }).catch(()=>{
	    this.$Message.error('网络错误');
	  });
	},
	getRechargeList(open_id){
		let p = {'open_id' : open_id}
	  this.http1.get('/open/rechargeList',{params:p}).then(response=>{
	    let data=response.data;
	    if(data.code!==0)
	    {
	      alert(data.message);
	    } else{
	      if (data.data) {
	        this.recharge_list = data.data;
	      }
	    }
	  }).catch(()=>{
	    this.$Message.error('网络错误');
	  });
	},
    closeModal(){
      this.app.id = 0;
      this.app.remark = '';
      this.app.appkey = '';
      this.app.appsecret = '';
      this.app.user_ids = '';
      this.app.start_time = '';
      this.app.end_time = '';
      this.status = 1;
    }
  }

}
</script>
